<template>
  <div>
    <HeaderCheckout />
    <Breadcrumbs title="continue shopping" />
    <div class="container" v-if="cart.items.length">
      <CheckoutTitle :title="title" />
      <div class="checkout-tab">
        <ul>
          <li v-for="(tab, index) in tabs" :key="'tab' + index" :class="activeTabId === index + 1 ? 'active' : ''" @click="getShoppingInfo(index + 1)">{{ tab.title }}</li>
        </ul>
        <div class="checkout-content" :class="activeTabId !== 3 ? 'mt-5' : 'mt-4'">
          <div class="header" v-if="activeTabId !== 2">{{activeTabTitle}}</div>

          <div v-if="activeTabId === 1" class="row mx-0 address-details">
            <div class="col-md-9 col-sm-12 p-0">
              <div class="d-flex align-items-center">
                <div id="address-company-name">{{cart.address.companyname}}<span class="mx-4">-</span></div>
                <div id="address-name">{{cart.address.firstname}} {{cart.address.middlename }} {{cart.address.lastname}} </div>
              </div>
              <div id="address-line">{{cart.address.addressline1}}</div>
              <div class="address-detail" v-if="cart.address.addressline2">{{cart.address.addressline2}}</div>
              <div class="address-detail">{{cart.address.city}}, {{cart.address.state}} {{cart.address.zipcode}}</div>
            </div>
            <div class="col-md-3 col-sm-12 text-md-right text-center p-0">
              <a class="btn delivery-btn ml-5" @click="getShoppingInfo(2, cart.address, 0)">deliver here</a>
            </div>
          </div>

          <div v-if="activeTabId === 1">
            <div class="row mx-0 address-details" v-for="(location, index) in cart.location_array" :key="'location' + index">
              <div class="col-md-9 col-sm-12 p-0">
                <div class="d-flex align-items-center">
                  <div id="address-company-name">{{location.companyname}}<span class="mx-4">-</span></div>
                  <div id="address-name">{{location.firstname}} {{location.middlename }} {{location.lastname}} </div>
                </div>
                <div id="address-line">{{location.addressline1}}</div>
                <div class="address-detail" v-if="location.addressline2">{{location.addressline2}}</div>
                <div class="address-detail">{{location.city}}, {{location.state}} {{location.zipcode}}</div>
              </div>
              <div class="col-md-3 col-sm-12 text-md-right text-center p-0">
                <a class="btn delivery-btn ml-5" @click="getShoppingInfo(2, location,location.id)">deliver here</a>
              </div>
            </div>
          </div>

          <div v-else-if="activeTabId === 2">
            <div class="text-right">
              <a class="btn delivery-btn delivery-small-btn mr-5" @click="order()">Submit Order</a>
            </div>
            <table class="table mt-4 review-table">
              <thead>
                <tr>
                  <th class="w-50">Shipping Address</th>
                  <th class="w-50">Payment</th>
                </tr>
              </thead>
              <tbody>

<!--              TODO JORGE: show dropdown to selected a different location (design by Noah). shoppingcard JSON contains now 'locations_array'
                  Depending on customer selecting the location (your dropdown) set selected_location_id to the value of locations_array[x].id
                  selected_location_id = 0 for main location. This way we know where to ship it.

                  Please use this new account that contains some additional locations: jorgenew@f4shion.com / TestBeta11
-->

                <tr>
                  <td class="address-details">
                    <div class="d-flex align-items-center">
                      <div id="address-company-name">{{activeLocation.companyname}}<span class="mx-4">-</span></div>
                      <div id="address-name">{{activeLocation.firstname}} {{activeLocation.middlename }} {{activeLocation.lastname}} </div>
                    </div>
                    <div id="address-line">{{activeLocation.addressline1}}</div>
                    <div class="address-detail" v-if="activeLocation.addressline2">{{activeLocation.addressline2}}</div>
                    <div class="address-detail">{{activeLocation.city}}, {{activeLocation.state}} {{activeLocation.zipcode}}</div>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div class="checkout-details" v-if="cart.items.length">
              <table class="table table-striped table-hover table-condensed">
                <thead>
                  <tr>
                    <th>Brand</th>
                    <th class="text-center">Item</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in cart.items" :key="index">
                    <td>{{ item.brand }}</td>

                    <td class="text-center">
                      <template v-if="item.rebate_text">
                        <div>{{ item.productname_checkout }}</div><div class="promo_percent_text">{{ item.rebate_text }}</div>
                      </template>
                      <template v-else>
                        <div>{{ item.productname_checkout }}</div>
                      </template>
                    </td>

                    <td>{{ item.quantity }}</td>
                    <td>${{ item.price_unit }}</td>
                    <td><strong>{{ item.price_total }}</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex align-items-center justify-content-between mr-md-5 mt-4">
              <router-link class="edit-cart" to="/shop/cart">Edit Cart</router-link>
              <a class="btn delivery-btn delivery-small-btn" @click="order()">Submit Order</a>
            </div>
          </div>

          <hr class="my-5" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import HeaderCheckout from '@/components/header'
import Breadcrumbs from '@/components/widgets/cart-breadcrumbs'
import CheckoutTitle from '@/components/widgets/cart-title'

export default {
  components: {
    HeaderCheckout,
    Breadcrumbs,
    CheckoutTitle
  },
  computed: {
    ...mapGetters({
      signedIn: 'auth/signedIn',
      storeIsOpen: 'auth/storeIsOpen',
      cart: 'cart/getCart',
      overallPromoCoupon: 'cart/getOverallPromoCoupon',
      webTotalDetails: 'cart/webTotalDetails',
      webTotalLines: 'cart/webTotalLines',
      paymenttype: 'cart/paymenttype',
      is_pickup: 'cart/is_pickup',
      is_drive_trough: 'cart/is_drive_trough',
      pickup_address: 'cart/pickup_address',
      webTotalTitle: 'cart/webTotalTitle',
      delivery_address: 'cart/getDeliveryAddress',
      full_name: 'auth/getFullName',
      getBlockCheckout: 'cart/getBlockCheckout',
      getFreeDeliveryText: 'cart/getFreeDeliveryText',
      getIsFreeDelivery: 'cart/getIsFreeDelivery',
      getWarningText: 'cart/getWarningText',
      license_management: 'auth/getLicenseManagement',
      getAccessToken: 'auth/getAccessToken',
      getLoaded: 'products/getLoaded',
      cart_is_signed_in: 'cart/cart_is_signed_in',
      pending_delivery: 'auth/pending_delivery',
    }),
  },
  mounted() {
    this.$store.dispatch('cart/loadShoppingCart')
  },
  data() {
    return {
      tabs: [
        { id: 1, title: "addresss" },
        { id: 2, title: "review & submit" }
      ],
      activeTabId: 1,
      title: "confirm address + license",
      activeTabTitle: "Shipping Address & License Number",
      special_instructions_message: '',
      selected_location_id: 0,
      activeLocation: {}
    }
  },
  watch: {
  },
  methods: {
    order() {
      this.$store.dispatch('cart/order', {
        special_instructions_message: this.special_instructions_message,
        location_id: this.selected_location_id,
      })
      this.$router.push('/shop/order-success')
    },
    getShoppingInfo(index, location={}, location_id){
      this.selected_location_id = location_id;
      this.activeTabId = index;
      this.activeTabTitle = index === 1 ? "Shipping Address & License Number" : "Review";
      this.title = index === 1 ? "confirm address + license" : "Review & Submit";
      this.activeLocation = Object.keys(location || {}).length != 0 ? location : this.cart.address;
    }
  }
}
</script>

<style scoped>

.promo_percent_text {
  color: red;
}

</style>
